import { SelectItem } from "@/models/api/SelectItem";
import CancellableHelper from "@/requests/CancellableHelper";
import { TemporaryRole } from "@/models/api/administration/temporaryRoles/TemporaryRole";
import {
  EditTemporaryRole,
  EditTemporaryRoleModel,
} from "@/models/api/administration/temporaryRoles/EditTemporaryRole";

//#region Routes
export const URL_GET_USER_TEMPORARY_ROLES = "/TemporaryRole/UserTemporaryRoles/${OfficeId}/${UserId}";
export const URL_GET_ROLES = "/TemporaryRole/Roles/${OfficeId}";
export const URL_POST_ADD_TEMPORARY_ROLE = "/TemporaryRole/Add/${UserId}";
export const URL_POST_EDIT_TEMPORARY_ROLE = "/TemporaryRole/Edit/${Id}";
export const URL_POST_TOGGLE_TEMPORARY_ROLE = "/TemporaryRole/Toggle/${Id}";
//#endregion

const _getUserTemporaryRoles = new CancellableHelper<Array<TemporaryRole>>(URL_GET_USER_TEMPORARY_ROLES, TemporaryRole);
export const getUserTemporaryRoles = async (officeId: string, userId: string): Promise<Array<TemporaryRole>> => {
  return await _getUserTemporaryRoles.get({ OfficeId: officeId, UserId: userId });
};

const _getRoles = new CancellableHelper<Array<SelectItem>>(URL_GET_ROLES, SelectItem);
export const getRoles = async (officeId: string): Promise<Array<SelectItem>> => {
  return await _getRoles.get({ OfficeId: officeId });
};

const _addTemporaryRole = new CancellableHelper<null>(URL_POST_ADD_TEMPORARY_ROLE, null, true);
export const addTemporaryRole = async (userId: string, model: EditTemporaryRole): Promise<null> => {
  return await _addTemporaryRole.post({ UserId: userId }, model);
};

const _editTemporaryRole = new CancellableHelper<null>(URL_POST_EDIT_TEMPORARY_ROLE, null, true);
export const editTemporaryRole = async (model: EditTemporaryRoleModel): Promise<null> => {
  return await _editTemporaryRole.post({ Id: model.id }, model as EditTemporaryRole);
};

const _toggleTemporaryRole = new CancellableHelper<null>(URL_POST_TOGGLE_TEMPORARY_ROLE, null, true);
export const toggleTemporaryRole = async (id: number): Promise<null> => {
  return await _toggleTemporaryRole.post({ Id: id }, null);
};
